<div [ngClass]="styleClass">
    <label
        *ngIf="label"
        for="{{ inputId }}"
        >{{ label }}</label
    >
    <p-select
        [attr.sera-read-only]="readOnly ? '' : null"
        [options]="options"
        [virtualScroll]="isVirtualScroll"
        [virtualScrollItemSize]="virtualItemSize"
        placeholder="{{ placeholder }}"
        [optionLabel]="'name'"
        [optionValue]="'key'"
        [optionDisabled]="'optionDisabled'"
        name="{{ label }}"
        inputId="{{ inputId }}"
        scrollHeight="{{ scrollHeight }}"
        [style]="style"
        [filter]="isFiltered"
        filterValue="{{ filterValue }}"
        [panelStyleClass]="panelStyleClass"
        filterBy="{{ filterBy }}"
        [filterMatchMode]="filterMatchMode"
        filterPlaceholder="{{ filterPlaceholder }}"
        [required]="required"
        [disabled]="isDisabled"
        [readonly]="readOnly"
        emptyMessage="{{ emptyMessage }}"
        emptyFilterMessage="{{ emptyFilterMessage }}"
        [panelStyle]="{ 'min-height': scrollHeight }"
        panelStyleClass="{{ panelStyleClass }}"
        dropdownIcon="{{ dropdownIcon }}"
        [showClear]="showClear && !readOnly"
        [(ngModel)]="value"
        (onChange)="selectionChanged.emit(value)"
        appendTo="body"
        [dropdownIcon]="readOnly ? 'none' : 'pi pi-chevron-down'"></p-select>
</div>
